module.exports = __webpack_public_path__ + "img/044.a9842f27.png";